export default __webpack_public_path__ + "static/media/login-header.614121d7.jpg";